module.exports = __webpack_public_path__ + "img/Constant Learner.b5ecf448.png";